import React, { useEffect, useState, useRef } from 'react';
import { Quotes } from '@phosphor-icons/react';
const testimonials = [{
  quote: 'Mateo brings far more than design to the table. He thinks holistically about product, and the depth of his craft made a real difference in how I learned to approach the work.',
  name: 'Alex Holder',
  title: "Design @ Dick's Sporting Goods",
  avatar: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/bdovfglt8tusyvarlsnd9f/5eeb8de3-4a4e-4cf2-9740-92477376f38e/Alex.jpg'
}, {
  quote: 'Mateo was the TA for our UX Design Bootcamp. He was unfailingly available and consistently went out of his way to help the cohort hit our goals.',
  name: 'Eric Lamontagne',
  title: 'Web Strategy Technical Lead',
  avatar: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/bdovfglt8tusyvarlsnd9f/5eeb8de3-4a4e-4cf2-9740-92477376f38e/Eric.jpg'
}, {
  quote: 'Working with Mateo is genuinely easy. His expertise and the way he collaborates make him the kind of teammate every project benefits from.',
  name: 'Tracey Jackson',
  title: 'A11y Specialist, Enterprise Banking',
  avatar: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/bdovfglt8tusyvarlsnd9f/5eeb8de3-4a4e-4cf2-9740-92477376f38e/Tracey.jpg'
}];
const clients = ['ELI LILLY', 'MERCOR', 'MICRO1', 'AARETE', 'CASE WESTERN RESERVE', 'U.S. BANK', 'AMERIPRISE FINANCIAL', 'EDWARD JONES', 'CORELOGIC', 'BURLINGTON CODE ACADEMY', 'DIALEXA (IBM)'];
export function TestimonialsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const currentSection = sectionRef.current;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -40px 0px'
    });
    if (currentSection) {
      observer.observe(currentSection);
    }
    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);
  return <section className="bg-white overflow-hidden" data-id="element-1715">
      <div ref={sectionRef} className="py-24 sm:py-32 md:py-40 px-6 sm:px-12 md:px-16 lg:px-24" data-id="element-1716">
        <div className="container mx-auto max-w-7xl" data-id="element-1717">
          {/* Unified Section Header */}
          <div className="mb-16 sm:mb-24" style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
          transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
        }} data-id="element-1718">
            <div className="text-xs tracking-[0.3em] uppercase text-slate-500 font-medium mb-4" style={{
            fontFamily: "'Ronzino', sans-serif"
          }} data-id="element-1719">
              FROM THE PEOPLE I'VE WORKED WITH
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-light text-slate-900 leading-tight mb-6" style={{
            fontFamily: "'Gefika', sans-serif"
          }} data-id="element-1720">
              Coworker Comments
            </h2>
            <div className="w-12 h-px bg-slate-900" data-id="element-1721"></div>
          </div>

          {/* Magazine Spread Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8" style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(40px)',
          transition: 'opacity 0.8s ease-out 0.3s, transform 0.8s ease-out 0.3s'
        }} data-id="element-1722">
            {/* Featured Testimonial */}
            <div className="lg:col-span-7 bg-white border border-slate-200 rounded-2xl p-8 sm:p-10 md:p-12 flex flex-col justify-between" data-id="element-1723">
              <div data-id="element-1724">
                <Quotes size={36} weight="fill" className="text-slate-500 mb-6" data-id="element-1725" />
                <p className="text-xl sm:text-2xl font-light leading-snug text-slate-900 mb-10 max-w-2xl" style={{
                fontFamily: "'Gefika', sans-serif"
              }} data-id="element-1726">
                  {testimonials[0].quote}
                </p>
              </div>
              <div data-id="element-1727">
                <div className="w-full h-px bg-slate-200 mb-6" data-id="element-1728"></div>
                <div className="flex items-center gap-4" data-id="element-1729">
                  <img src={testimonials[0].avatar} alt={testimonials[0].name} className="w-16 h-16 rounded-full object-cover border border-slate-100 grayscale" data-id="element-1730" />
                  <div data-id="element-1731">
                    <div className="text-sm font-semibold text-slate-900" data-id="element-1732">
                      {testimonials[0].name}
                    </div>
                    <div className="text-xs uppercase tracking-[0.15em] text-slate-500 mt-1" data-id="element-1733">
                      {testimonials[0].title}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Stacked Testimonials */}
            <div className="lg:col-span-5 flex flex-col gap-6" data-id="element-1734">
              {testimonials.slice(1).map((testimonial, index) => <div key={index} className="bg-white border border-slate-200 rounded-2xl p-8 sm:p-10 flex-1 flex flex-col justify-between" data-id="element-1735">
                  <div data-id="element-1736">
                    <Quotes size={28} weight="fill" className="text-slate-500 mb-6" data-id="element-1737" />
                    <p className="text-base sm:text-lg text-slate-700 leading-relaxed mb-6" data-id="element-1738">
                      {testimonial.quote}
                    </p>
                  </div>
                  <div data-id="element-1739">
                    <div className="w-full h-px bg-slate-200 mb-6" data-id="element-1740"></div>
                    <div className="flex items-center gap-4" data-id="element-1741">
                      <img src={testimonial.avatar} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover border border-slate-100 grayscale" data-id="element-1742" />
                      <div data-id="element-1743">
                        <div className="text-sm font-semibold text-slate-900" data-id="element-1744">
                          {testimonial.name}
                        </div>
                        <div className="text-xs uppercase tracking-[0.15em] text-slate-500 mt-1" data-id="element-1745">
                          {testimonial.title}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Quiet Client Marquee */}
          <div className="mt-16 sm:mt-24 py-8 border-t border-slate-200 relative" style={{
          opacity: isVisible ? 1 : 0,
          transition: 'opacity 0.8s ease-out 0.6s'
        }} data-id="element-1746">
            <div className="flex overflow-hidden group" style={{
            maskImage: 'linear-gradient(to right, transparent, black 10%, black 90%, transparent)',
            WebkitMaskImage: 'linear-gradient(to right, transparent, black 10%, black 90%, transparent)'
          }} data-id="element-1747">
              <div className="flex whitespace-nowrap animate-[marquee_30s_linear_infinite] group-hover:[animation-play-state:paused]" data-id="element-1748">
                {[...clients, ...clients, ...clients].map((client, i) => <div key={i} className="flex items-center" data-id="element-1749">
                    <span className="text-xs tracking-[0.25em] text-slate-500 uppercase px-8" style={{
                  fontFamily: "'Ronzino', sans-serif"
                }} data-id="element-1750">
                      {client}
                    </span>
                    <span className="text-slate-300 text-xs" data-id="element-1751">•</span>
                  </div>)}
              </div>
            </div>
          </div>
        </div>
      </div>
      <style dangerouslySetInnerHTML={{
      __html: `
        @keyframes marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-33.3333%); }
        }
      `
    }} data-id="element-1752" />
    </section>;
}